import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { addDevicesUrl } from '../../config';
import api from '../../api';
import { Status } from '../../common/constants';
import {
  IDevicePayload,
  IDevice,
  IDeviceSetupState,
} from '../../common/types/devicesTypes';
import { getCookie } from '../../common/utils';

const ADD_DEVICE: string = 'addDevice';

const initialState: IDeviceSetupState = {
  devices: [],
  status: null,
  error: null,
  reqId: null,
  msg: null,
};

interface IAddDeviceResponse {
  data: IDevice;
  message: string;
}

export const addDevice = createAsyncThunk(
  ADD_DEVICE,
  async (payload: IDevicePayload, { rejectWithValue }) => {
    try {
      const organizationId: string = getCookie('organizationId');
      const response = await api.put<IAddDeviceResponse>(
        addDevicesUrl,
        payload,
        { headers: { organizationId: organizationId } }
      );
      const addDeviceResponse: IAddDeviceResponse = response.data;
      return addDeviceResponse;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

const deviceSetupSlice = createSlice({
  name: ADD_DEVICE,
  initialState,
  reducers: {
    clearAddDeviceData: (state: IDeviceSetupState) => {
      state.devices = [];
      state.status = null;
      state.msg = null;
      state.error = null;
      state.reqId = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addDevice.pending, (state) => {
        state.status = Status.PENDING;
        state.msg = null;
      })
      .addCase(addDevice.fulfilled, (state, action) => {
        state.devices = [...state.devices, action.payload.data];
        state.msg = action.payload.message;
        state.status = Status.SUCCESS;
      })
      .addCase(addDevice.rejected, (state, action) => {
        const errorPayload = action.payload as {
          response?: {
            data?: { error?: { message?: string }; message?: string };
          };
        };
        state.msg =
          errorPayload.response?.data?.error?.message ||
          errorPayload.response?.data?.message ||
          'Unknown error occurred';
        state.reqId = Math.random();
        state.status = Status.FAILED;
      });
  },
});

export default deviceSetupSlice.reducer;
export const { clearAddDeviceData } = deviceSetupSlice.actions;
